export default {
  computed: {
    capturingScreenshots() {
      return false;
    },
  },
};
